import { Spread } from 'editor/src/store/design/types';
import isPagePrintable from 'editor/src/store/design/util/isPagePrintable';

/**
 * Size in mm of the box around a spread's printable content areas. Content, not mediabox:
 * the mediabox carries the bleed, which is not part of what the buyer gets printed.
 */
const getSpreadPrintAreaSize = (spread: Spread | undefined): { width: number; height: number } | undefined => {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  spread?.pages.forEach((page) => {
    if (!isPagePrintable(page)) {
      return;
    }
    page.groups.content?.forEach((content) => {
      if (content.type !== 'area' || !content.width || !content.height) {
        return;
      }
      minX = Math.min(minX, page.x + content.x);
      minY = Math.min(minY, page.y + content.y);
      maxX = Math.max(maxX, page.x + content.x + content.width);
      maxY = Math.max(maxY, page.y + content.y + content.height);
    });
  });

  return maxX > minX && maxY > minY ? { width: maxX - minX, height: maxY - minY } : undefined;
};

export default getSpreadPrintAreaSize;
